import { isPlatformBrowser } from '@angular/common';
import { Component, OnInit, Input, Inject, PLATFORM_ID } from '@angular/core';
import { ProductInfo } from '@app-model/product';
import { ProductService } from '@app-services/product.service';

@Component({
	selector: 'app-qr-code',
	templateUrl: './qr-code.component.html',
	styleUrls: ['./qr-code.component.scss']
})
export class QRCodeComponent implements OnInit {
	@Input() url: string;
	@Input() width?: number;

	showQRCode = false;

	constructor(@Inject(PLATFORM_ID) private platformId: Object, private productService: ProductService) {

	}

	ngOnInit() {
		this.showQRCode = isPlatformBrowser(this.platformId);
		if (!this.width) {
			this.width = 256;
		}

		this.productService.getProductInfo().subscribe(p => {
			this.url = QRCodeComponent.getUtmUrl(this.url, p);
		});
	}

	static getUtmUrl(url: string, product: ProductInfo): string {
		if (!url) {
			return url;
		}
		const utmParams = `utm_source=${product.name}&utm_medium=QRCode`;
		let paramsSeparator;
		if (url.indexOf('?') >= 0) {
			paramsSeparator = '&';
		} else {
			paramsSeparator = '?';
		}

		url += paramsSeparator + utmParams;
		return url;
	}
}
